import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EditingMode } from '../../models/editingMode';
import { Role } from "../../models/role";
import { AuthService } from '../../auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ValidacionesService } from './validaciones.service';
import { Validacion } from '../../../asistente-en-linea/models/Validacion';
import { TipoValidacion } from '../../../asistente-en-linea/models/TipoValidacion';
import { DeleteValidacionDialogComponent } from './dialog/delete/delete-validacion-dialog.component';
import { TiposValidacionesService } from './tiposvalidaciones.service';
import { MatSort } from '@angular/material/sort';
import { ImportDestinatarioValidacionDialogComponent } from '../menu/dialog/importdestval/import-destval-dialog.component';

@Component({
  selector: 'app-validaciones',
  templateUrl: './validaciones.component.html',
  styleUrls: ['./validaciones.component.scss']
})
export class ValidacionesComponent implements OnInit {
  cargandoDatos: boolean;
  validaciones: Validacion[];
  validacionesBackup: Validacion[];
  validacionSeleccionada: Validacion;
  faq: any;
  visiblePath: string;
  maxPathLength: number = 100;
  puedeCrearOEliminar: boolean;
  mostrarError: boolean;
  eliminarSeleccionado: boolean;
  habilitarBotonEliminar: boolean
  habilitarBotones: boolean;
  selectedFile: any = null;
  formData: any = null;
  // Indica el modo de edicion ; si es OFF entonces el panel derecho queda sin informacion
  editingMode: EditingMode;
  displayedColumns = ['id', 'codigo', 'nombre', 'tipo', 'fechaActualizacion', 'usuarioActualizador'];
  dataSource: any;
  selection: any;
  filtroCodigo: string = '';
  filtroNombre: string = '';
  initialSelection: any;
  allowMultiSelect: boolean;
  tipoFiltrado: TipoValidacion;
  tiposValidaciones: TipoValidacion[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  constructor(private validacionesService: ValidacionesService, private tiposValidacionesService: TiposValidacionesService, private route: ActivatedRoute, private router: Router, private authService: AuthService, public dialog: MatDialog) {
    this.editingMode = EditingMode.Off;
    this.puedeCrearOEliminar = false;
    this.eliminarSeleccionado = false;
    this.habilitarBotones = false;
    this.initialSelection = [];
    this.allowMultiSelect = false;
    this.validacionesBackup = [];
    this.habilitarBotonEliminar = false;
    this.selection = new SelectionModel<Validacion>(this.allowMultiSelect, this.initialSelection);
  }



  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    for (let role of this.authService.getUser().roles) {
      if (role == Role.Admin || role == Role.MenuAdministrator) {
        this.puedeCrearOEliminar = true;
        break;
      }
    }
    this.loadValidacionesTipos();
    this.loadValidaciones();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  volver() {
    this.router.navigate(['/config/home']);
  }
  
  seleccionarValidacion(element) {
    this.selection.toggle(element);
    this.habilitarBotones = false;
    let esNuevoMenu = false;
    this.habilitarBotonEliminar = false;
    if (!this.validacionSeleccionada) {
      esNuevoMenu = true;
      this.validacionSeleccionada = element;
    } else if (element && this.validacionSeleccionada) {
      if (element.id != this.validacionSeleccionada.id) {
        this.validacionSeleccionada = element;
        esNuevoMenu = true;
      } else {
        this.validacionSeleccionada = undefined;
      }
    }

    if (esNuevoMenu) {
      if (this.validacionSeleccionada && this.validacionSeleccionada.id) {
        this.habilitarBotones = true;
        if (!this.validacionSeleccionada.habilitado) {
          this.habilitarBotonEliminar = true;
        }
      }
    }
  }
  salirAdministrador() {
    this.validacionesService.salirAdministrador();
    this.router.navigate(["/login"]);
  }


  getFormattedDate(date) {
    if(date) {
      let year = date.getFullYear();
      let month = (1 + date.getMonth()).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');

      let hour = date.getHours().toString().padStart(2, '0');
      let minutes = date.getMinutes().toString().padStart(2, '0');
      let seconds = date.getSeconds().toString().padStart(2, '0');
      return day + '/' + month + '/' + year + " " + hour + ":" + minutes + ":" + seconds;
    }
    return "";
    
  }
  loadValidacionesTipos() {
    this.cargandoDatos = true;
    this.tiposValidaciones = [];
    this.tiposValidacionesService.loadTiposValidaciones(false).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let tipoVal = new TipoValidacion(
              m.id,
              m.codigo,
              m.nombre,
              m.campos
            );
            this.tiposValidaciones.push(tipoVal);
          }
        }
        this.cargandoDatos = false;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    }, error => {
      alert(error);
      this.cargandoDatos = false;
    })
  }
  loadValidaciones() {
    this.validaciones = [];
    this.validacionesBackup = [];
    this.cargandoDatos = true;
    this.validacionesService.loadValidaciones(false).subscribe((data: any) => {
      //debugger
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let destinatario = new Validacion(
              m.id,
              m.codigo,
              m.nombre,
              m.tipo,
              m.fechaCreacion ? this.getFormattedDate(new Date(m.fechaCreacion)) : "",
              m.fechaActualizacion ? this.getFormattedDate(new Date(m.fechaActualizacion)) : "",
              m.usuarioActualizador,
              m.habilitado
            );
            this.validaciones.push(destinatario);
            this.validacionesBackup.push(destinatario);
          }

        }
        this.dataSource = new MatTableDataSource(this.validaciones);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.cargandoDatos = false;
        this.eliminarSeleccionado = false;
        this.habilitarBotonEliminar = false;
        this.habilitarBotones = false;
        this.validacionSeleccionada = undefined;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
      })
  }

  seleccionarParaEliminar() {
    this.eliminarSeleccionado = false;
    if (this.validacionSeleccionada && this.validacionSeleccionada.id) {
      const dialogRef = this.dialog.open(DeleteValidacionDialogComponent, {
        width: '400px',
        minHeight: '24vh',
        data: this.validacionSeleccionada
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.loadValidaciones();
        }
      });
    }

  }


  editarValidacion() {
    if (this.validacionSeleccionada && this.validacionSeleccionada.id) {
      this.router.navigate(['/config/validacion/'], { queryParams: { idValidacion: this.validacionSeleccionada.id } });
    }
  }

  nuevaValidacion() {
    this.router.navigate(['/config/validacion/']);
  }


  cancelDeleteOperation() {

    this.eliminarSeleccionado = false;
  }


  onSelected(selectedValue: any) {
    //TO DO: Borrar console log
    console.log('seleccionado:', selectedValue);
  }

/** 
  aplicarFiltro(): void {
    if(this.tipoFiltrado) {
      this.validaciones = this.validacionesBackup.filter(x => this.tipoFiltrado == undefined || x.tipo.codigo == this.tipoFiltrado.codigo);
      this.dataSource = new MatTableDataSource(this.validaciones);
    } else {
      this.dataSource = new MatTableDataSource(this.validacionesBackup);
    }
    this.dataSource.sort = this.sort;
  }
**/
  aplicarFiltro(): void {
    if(this.tipoFiltrado || this.filtroCodigo || this.filtroNombre) {
      this.validaciones = this.validacionesBackup.filter(x => this.tipoFiltrado == undefined || x.tipo.codigo == this.tipoFiltrado.codigo);
    
      if(this.filtroCodigo && this.filtroCodigo !="" && this.filtroCodigo.trim().length > 0) {
        this.validaciones = this.validaciones.filter(m => m.codigo?.toUpperCase().includes(this.filtroCodigo.trim().toUpperCase()));
      }
  
      if(this.filtroNombre && this.filtroNombre !="" && this.filtroNombre.trim().length > 0) {
        this.validaciones = this.validaciones.filter(m => m.nombre?.toUpperCase().includes( this.filtroNombre.trim().toUpperCase()));
      }
      this.dataSource = new MatTableDataSource(this.validaciones);
    } else {
      this.dataSource = new MatTableDataSource(this.validacionesBackup);
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    
  }

  cargarArchivo() {
    const dialogRef = this.dialog.open(ImportDestinatarioValidacionDialogComponent, {
      width: '600px',
      minHeight:'260px',
      //min-height: '400px',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadValidaciones();
    });
  }
  cancelarCargarArchivo() {
    this.selectedFile = null;
  }
}